var React = require('react');

function Public (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 0C3.582 0 0 3.582 0 8C0 12.418 3.582 16 8 16C12.418 16 16 12.418 16 8C16 3.582 12.418 0 8 0ZM10.6667 13.3667V9.88533C10.6667 9.53133 10.526 9.19266 10.276 8.94266L9.05733 7.724C8.80733 7.474 8.468 7.33333 8.11466 7.33333H6C5.264 7.33333 4.66667 7.93067 4.66667 8.66667V9.70599C4.66667 10.28 5.034 10.7893 5.57867 10.9707L5.75534 11.0293C6.3 11.2107 6.66733 11.72 6.66733 12.294V13.8453C3.99933 13.2367 2.00067 10.8493 2.00067 8C2.00067 5.65 3.362 3.61733 5.334 2.63333V4.66667C5.334 5.40267 5.93133 6 6.66733 6H8.782C9.13534 6 9.47466 6.14067 9.72466 6.39067L10.9433 7.60932C11.1933 7.85932 11.5327 8 11.886 8H14C14 10.35 12.6387 12.3827 10.6667 13.3667Z","fill":"currentColor"}));
}

Public.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Public;

Public.default = Public;
